<template>

    <v-dialog
        :value="open"
        lazy
        max-width="450px"
        @input="closeDeletionModalHandle"
    >
        <v-card>
            <v-card-title>
                <v-layout justify-end>
                    <v-btn icon @click="closeDeletionModalHandle">
                        <v-icon color="#4A4A4A">mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text class="px-4">
                <h2 class="section-title text-xs-center study-form__title mx-0">
                    {{ $t('Вы действительно хотите удалить событие?') }}
                </h2>
            </v-card-text>
            <v-card-actions class="study-form__padding">
                <v-layout justify-center class="study-form__actions">
                    <button-white
                        class="study-form__btn"
                        @click.native="closeDeletionModalHandle"
                    >
                        {{ $t("Отмена") }}
                    </button-white>
                    <button-red
                        class="study-form__btn"
                        @click.native="confirmDeletionHandle"
                    >
                        {{ $t("Удалить") }}
                    </button-red>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import ButtonWhite from "@/components/ui/buttons/button_bd_white.vue";
import ButtonRed from "@/components/ui/buttons/button_red.vue";

export default {
    components: { ButtonRed, ButtonWhite },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        closeDeletionModalHandle() {
            this.$emit('close');
        },
        confirmDeletionHandle() {
            this.$emit('confirm');
        }
    },
}
</script>
